import { render, staticRenderFns } from "./btnMostrar.vue?vue&type=template&id=3b5bb411&"
import script from "./btnMostrar.vue?vue&type=script&lang=js&"
export * from "./btnMostrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports